import LoadingDots from 'components/Loader/LoadingDots'
import TypographyPrimary from 'components/Typography/Primary'
import styled from 'styled-components'

type ImagesWindowProps = {
    loading: boolean
    images: string[]
    displayPrompt: string
}

const ImagesChatWindow = ({ loading, images, displayPrompt }: ImagesWindowProps) => {
    return (
        <StyledImageChatWrapper>
            {loading ? (
                <>
                    <TypographyPrimary value={displayPrompt} bold size='x-large' semiBold />
                    <LoadingDots large />
                </>
            ) : (
                images?.length > 0 && <StyledImg src={images?.[0]} />
            )}
        </StyledImageChatWrapper>
    )
}

export default ImagesChatWindow

const StyledImageChatWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 20px;

    width: 100%;
    height: 100%;

    overflow: auto;
`
const StyledImg = styled.img`
    height: 95%;

    object-fit: contain;

    border-radius: 10px;
`
